import { useState } from "react";
import { View } from "react-native";
import { Button, Text, TextInput } from "react-native-paper";
import Colors from "../../../src/resources/Colors";

export const ModalContent = ({ template, onSend }) => {
    const variables = Array.from(template.body.matchAll(/{{([0-9]+)}}/g), m => String(m[1]));
    const [valores, setValores] = useState({});

    const handleSend = () => {
        let textoFinal = template.body;
        Object.keys(valores).forEach(key => {
            textoFinal = textoFinal.replace(key, valores[key]);
        });
        onSend(valores, textoFinal);
    };

    return (
        <View style={{ padding: 10, width: 500 }}>
            <Text style={{ fontStyle: 'italic', marginTop: 10, marginBottom:10 }}>
                Vista previa: {template.body.replace(/{{[0-9]+}}/g, (m, id) => valores[id] || m)}
            </Text>
            {variables.map(v => (
                <TextInput
                    key={v}
                    value={valores[String(v)] || ""}
                    placeholder={`Texto {{${v}}}`}
                    //style={styles.input}
                    onChangeText={(txt) => setValores({ ...valores, [String(v)]: txt })}
                />
            ))}
            <Button styles={Colors.primary} onPress={handleSend}>Enviar</Button>
        </View>
    );
};